import { Navigate, Outlet } from "react-router-dom";
import { getUser } from "@/store/slices/auth";
import { useAppSelector } from "@/store/hooks";
const RoleGuards = ({ role }) => {
  const user = useAppSelector(getUser);

  return user?.role === role ? <Outlet /> : <Navigate to="/notFound" />;
};
export default RoleGuards;
